import { render } from "./BrandedLoader.vue?vue&type=template&id=29f8bb6a&scoped=true"
import script from "./BrandedLoader.vue?vue&type=script&lang=js"
export * from "./BrandedLoader.vue?vue&type=script&lang=js"

import "./BrandedLoader.vue?vue&type=style&index=0&id=29f8bb6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f8bb6a"]])

export default __exports__